export default __webpack_public_path__ + "static/media/52-IvanhoeCambridge.64892329.jpg";